<template>
  <app-navigation :title="toolbarTitle">
    <spinner :loading="loadingRequest">
      <request-response-placeholder
        :message="messagePlaceholder"
        :showPlaceholder="showRequestPlaceholder">
        <v-layout justify-center row wrap mt-2>
          <student-card
            v-for="student in students"
            :key="student.id"
            :student="student"
            @click="navigateToMeals"
            button_label="Visualizar refeições"/>
        </v-layout>
      </request-response-placeholder>
    </spinner>
  </app-navigation>

</template>

<script>
import RequestResponsePlaceholder from '@/components/RequestResponsePlaceholder'
import Spinner from '@/components/Spinner'
import StudentCard from '@/components/StudentCard'
import AppNavigation from '@/layouts/AppNavigation'

import { mapActions, mapState } from 'vuex'

export default {
  name: 'MealControl',

  components: {
    AppNavigation,
    RequestResponsePlaceholder,
    Spinner,
    StudentCard
  },

  data: () => ({
    emptyMessage: 'Não há alunos registrados.',
    errorMessage: 'Não foi possível buscar pelos estudantes.',
    responsible_id: 1,
    toolbarTitle: 'Controle de Refeições'
  }),

  computed: {
    ...mapState({
      errorRequest: state => state.mealControl.errorRequest,
      loadingRequest: state => state.mealControl.loadingRequest,
      students: state => state.mealControl.listStudents
    }),

    messagePlaceholder () {
      return this.errorRequest ? this.errorMessage : this.emptyMessage
    },

    showRequestPlaceholder () {
      return this.errorRequest !== null || this.students.length === 0
    }
  },

  mounted () {
    this.getStudents(this.responsible_id)
  },

  methods: {
    ...mapActions({
      getStudents: 'mealControl/getStudents'
    }),

    navigateToMeals (studentId) {
      this.$router.push({ name: 'meal_control_trays', params: { id: studentId } })
    }
  }
}
</script>
